module.exports = __webpack_public_path__ + "img/flag_en.ac535f2.png";